import { getField } from 'vuex-map-fields';
export default {
    getField
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Marketing/getters.js